
import React from "react";
import { Button } from "@/components/ui/button";
import { Database, RefreshCw } from "lucide-react";
import RolePermissionsTable from "./RolePermissionsTable";
import DatabaseStatus from "./DatabaseStatus";
import { Permission, Resource, PermissionType, Role } from "@/hooks/rollenbeheer/types";

interface RollenBeheerContentProps {
  isLoading: boolean;
  permissions: Permission[];
  onUpdatePermission: (role: Role, resource: Resource, permissionType: PermissionType, value: boolean) => void;
  databaseInitialized: boolean;
  lastSaveTime: string | null;
  onRefresh: () => void;
}

const RollenBeheerContent: React.FC<RollenBeheerContentProps> = ({
  isLoading,
  permissions,
  onUpdatePermission,
  databaseInitialized,
  lastSaveTime,
  onRefresh
}) => {
  if (isLoading) {
    return (
      <div className="text-center p-6">
        <p>Rechten laden...</p>
      </div>
    );
  }

  if (!permissions || permissions.length === 0) {
    return (
      <div className="text-center p-6 text-red-500">
        <p>Geen rechten gevonden. Vernieuw de pagina.</p>
        <Button 
          variant="outline" 
          className="mt-4"
          onClick={onRefresh}
        >
          <RefreshCw className="mr-2 h-4 w-4" />
          Pagina herladen
        </Button>
      </div>
    );
  }

  return (
    <>
      <DatabaseStatus 
        databaseInitialized={databaseInitialized}
        lastSaveTime={lastSaveTime}
      />
      <RolePermissionsTable 
        permissions={permissions} 
        onUpdatePermission={onUpdatePermission}
      />
    </>
  );
};

export default RollenBeheerContent;
